import type { MachineGroup, MenuTreeItem } from '@/shared/types/machine.types';
import { machineGroupsSchema } from '@/shared/validation/machine.validation';

const toSidegroup = (node: MenuTreeItem) => {
  const { items, ...rest } = node;
  return { ...rest, machines: items };
};

const toSubgroup = (node: MenuTreeItem) => {
  const { items, ...rest } = node;
  return { ...rest, sidegroups: items?.map(toSidegroup) ?? [] };
};

const toGroup = (node: MenuTreeItem) => {
  const { items, ...rest } = node;
  return { ...rest, subgroups: items?.map(toSubgroup) ?? [] };
};

/**
 * Reshapes Pimcore's recursive menu-tree into the fixed four-level taxonomy
 * (group → subgroup → sidegroup → machines). The final schema parse strips
 * fields outside the taxonomy shape, e.g. `items` nested below machine level.
 */
export const menuTreeToMachineGroups = (menuTree: MenuTreeItem[]): MachineGroup[] =>
  machineGroupsSchema.parse(menuTree.map(toGroup));
